module.exports = __webpack_public_path__ + "static/sport/register-img.e881b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register-img.png
// module id = Of1O
// module chunks = 0